import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { InitializationService } from '../core/services/initialization.service';
import { environment } from '@environment';
import { GdprPortalDTO } from '../../sb-tools/typescript/models/dto/gdpr-portal.dto';
import { NavbarComponent } from '../navbar/navbar.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-portals',
    templateUrl: './portals.component.html',
    styleUrls: ['./portals.component.scss'],
    imports: [NavbarComponent, FormsModule, RouterLink, TranslateModule],
})
export class PortalsComponent implements OnInit {
    communityName: string;
    filteredPortals: GdprPortalDTO[];
    newPortalLink: string;
    portals: GdprPortalDTO[];
    searchName = '';

    constructor(
        private router: Router,
        private initializationService: InitializationService,
    ) {
        this.portals = this.initializationService.portals;
        this.communityName = this.initializationService.communityName;
        this.newPortalLink = environment.inboxUrl + '/' + this.communityName + '/admin/community/accessRequestPortal';
    }

    ngOnInit() {
        if (this.portals.length === 1) {
            this.router.navigate(['/', this.communityName, this.portals[0].name, 'requests']);
        }
        this.filteredPortals = this.portals;
    }

    search() {
        this.filteredPortals = this.portals.filter((portal) => {
            return portal.name.includes(this.searchName);
        });
    }

    clearSearchName() {
        this.searchName = '';
        this.filteredPortals = this.portals;
    }
}
